import {
  TextDataType,
  enUSTextData,
  esESTextData,
  idIDTextData,
  jaJPTextData,
  thTHTextData,
  zhCNTextData,
  zhTWTextData,
} from '@/datas/LocaleData';
import { deDETextData, koKRTextData, ruRUTextData, viVNTextData } from '@/datas/LocaleDataExtra';
import { normalizeLanguageCode } from '@/i18n/config';

const languageCodeMap: Record<string, TextDataType> = {
  'zh-CN': zhCNTextData,
  'zh-TW': zhTWTextData,
  'en-US': enUSTextData,
  'ja-JP': jaJPTextData,
  'es-ES': esESTextData,
  'th-TH': thTHTextData,
  'id-ID': idIDTextData,
  'ko-KR': koKRTextData,
  'de-DE': deDETextData,
  'ru-RU': ruRUTextData,
  'vi-VN': viVNTextData,
};

export function getLanguageDataByCode(languageCode?: string | null): TextDataType {
  return languageCodeMap[normalizeLanguageCode(languageCode)] ?? enUSTextData;
}
